import { GeoPoint, Image } from './';

export enum Status {
  Active = 'active',
  Archive = 'archived',
}

export interface Establishment {
  id: string;
  name: string;
  status: Status,
  openFrom: string;
  openTill: string;
  city: string;
  address: string;
  phone: string;
  location: GeoPoint;
  delivery: boolean;
  pickup: boolean;
  tags: string[];
  coverImage: Image;
  coverImg:any;
}
